export default [
  {
    path: '/admin/trader/entry-router',
    name: 'EntryRouter',
    component: () => import('@/views/Admin/Trader/EntryRouter/Index.vue'),
    meta: {
      pageTitle: 'Entry Router',
      breadcrumb: [
        { text: 'Trader', active: false },
        { text: 'Entry Router', active: true },
      ],
      resource: 'indicators.list',
      action: 'read',
    },
  },
]
